import { ReactNode } from 'react';
import Typography from '@mui/material/Typography';

/*
*   Заголовок страниц (Второстепенный H2)
*/

type ITitlePageH2 = {
    children: ReactNode,
}


export function TitlePageH2({
    children,
}: ITitlePageH2) {

    return (
        <Typography
            component='h2'
            variant='h6'
            sx={{ mt: 4, mb: 1 }}
        >
            {children}
        </Typography>
    );
}